
export default "/assets/share-micro.8ec589d9.svg"